import { Link, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useCart } from '../../context/CartContext';
import { useWishlist } from '../../context/WishlistContext';
import SearchModal from '../../components/feature/SearchModal';
import SizeGuideModal from '../../components/feature/SizeGuideModal';

export default function ProductPage() {
  const { id } = useParams();
  const [selectedSize, setSelectedSize] = useState('M');
  const [selectedColor, setSelectedColor] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState(0);
  const [addedToCart, setAddedToCart] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [collectionDropdownOpen, setCollectionDropdownOpen] = useState(false);
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [sizeGuideOpen, setSizeGuideOpen] = useState(false);
  const [localCurrency, setLocalCurrency] = useState<{ code: string; symbol: string; rate: number } | null>(null);
  const { addToCart, totalItems } = useCart();
  const { addToWishlist, isInWishlist, removeFromWishlist, totalItems: wishlistTotal } = useWishlist();

  const currencyRates: Record<string, { code: string; symbol: string; rate: number }> = {
    HK: { code: 'HKD', symbol: 'HK$', rate: 7.83 },
    AU: { code: 'AUD', symbol: 'A$', rate: 1.53 },
    NZ: { code: 'AUD', symbol: 'A$', rate: 1.53 },
    TW: { code: 'TWD', symbol: 'NT$', rate: 31.50 },
  };

  useEffect(() => {
    const detectCurrency = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        const countryCode = data.country_code;
        
        if (currencyRates[countryCode]) {
          setLocalCurrency(currencyRates[countryCode]);
        }
      } catch (error) {
        console.error('Failed to detect location:', error);
      }
    };

    detectCurrency();
  }, []);

  const allProducts = [
    { 
      id: 1, 
      name: 'ESSENCE HOODIE', 
      quote: 'Be the change you wish to see', 
      price: 119, 
      category: 'hoodies', 
      description: 'A timeless piece that speaks to the soul. Crafted from premium organic cotton with a brushed interior for ultimate comfort. Features a minimalist design with carefully placed typography that makes a statement without shouting.', 
      sizes: ['S', 'M', 'L', 'XL'], 
      colors: ['Black', 'Charcoal', 'Navy'], 
      details: ['Premium organic cotton blend', 'Brushed interior lining', 'Screen-printed graphics', 'Relaxed fit', 'Machine washable'], 
      colorImages: {
        'Black': [
          'https://public.readdy.ai/ai/img_res/32f8c9b0d56a613201b95eec88090a31.jpg',
          'https://readdy.ai/api/search-image?query=premium%20black%20cotton%20hoodie%20back%20view%20with%20philosophical%20quote%20typography%20displayed%20on%20clean%20white%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20luxury%20streetwear%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=essence-black-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20black%20cotton%20hoodie%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20quote%20typography%20print%20quality%20on%20clean%20white%20background%20luxury%20streetwear%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=essence-black-detail&orientation=portrait'
        ],
        'Charcoal': [
          'https://readdy.ai/api/search-image?query=premium%20charcoal%20grey%20cotton%20hoodie%20with%20philosophical%20quote%20typography%20printed%20in%20elegant%20serif%20font%20on%20chest%20area%20displayed%20on%20clean%20white%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20and%20print%20detail%20luxury%20streetwear%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=essence-charcoal-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20charcoal%20grey%20cotton%20hoodie%20back%20view%20with%20philosophical%20quote%20typography%20displayed%20on%20clean%20white%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20luxury%20streetwear%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=essence-charcoal-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20charcoal%20grey%20cotton%20hoodie%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20quote%20typography%20print%20quality%20on%20clean%20white%20background%20luxury%20streetwear%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=essence-charcoal-detail&orientation=portrait'
        ],
        'Navy': [
          'https://readdy.ai/api/search-image?query=premium%20navy%20blue%20cotton%20hoodie%20with%20philosophical%20quote%20typography%20printed%20in%20elegant%20serif%20font%20on%20chest%20area%20displayed%20on%20clean%20white%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20and%20print%20detail%20luxury%20streetwear%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=essence-navy-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20navy%20blue%20cotton%20hoodie%20back%20view%20with%20philosophical%20quote%20typography%20displayed%20on%20clean%20white%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20luxury%20streetwear%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=essence-navy-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20navy%20blue%20cotton%20hoodie%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20quote%20typography%20print%20quality%20on%20clean%20white%20background%20luxury%20streetwear%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=essence-navy-detail&orientation=portrait'
        ]
      }
    },
    { 
      id: 2, 
      name: 'CLARITY TEE', 
      quote: 'Same shit Different day', 
      price: 79, 
      category: 'tees', 
      description: 'Simplicity at its finest. Made from 100% organic cotton with a relaxed fit. The bold statement print adds character while maintaining an understated elegance. Perfect for everyday wear.', 
      sizes: ['S', 'M', 'L', 'XL'], 
      colors: ['White', 'Black', 'Grey'], 
      details: ['100% organic cotton', 'Relaxed fit', 'Screen-printed design', 'Pre-shrunk fabric', 'Tagless for comfort'], 
      colorImages: {
        'White': [
          'https://readdy.ai/api/search-image?query=premium%20white%20luxury%20t-shirt%20with%20bold%20black%20text%20Same%20shit%20Different%20day%20printed%20in%20modern%20typography%20on%20chest%20minimalist%20design%20high%20quality%20organic%20cotton%20fabric%20clean%20simple%20background%20emphasizing%20product%20details%20sophisticated%20streetwear%20aesthetic%20quiet%20luxury%20style%20professional%20product%20photography&width=600&height=800&seq=clarity-white-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20white%20cotton%20t-shirt%20back%20view%20displayed%20on%20clean%20white%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20luxury%20basics%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=clarity-white-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20white%20cotton%20t-shirt%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20print%20quality%20on%20clean%20white%20background%20luxury%20basics%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=clarity-white-detail&orientation=portrait'
        ],
        'Black': [
          'https://readdy.ai/api/search-image?query=premium%20black%20luxury%20t-shirt%20with%20bold%20white%20text%20Same%20shit%20Different%20day%20printed%20in%20modern%20typography%20on%20chest%20minimalist%20design%20high%20quality%20organic%20cotton%20fabric%20clean%20simple%20background%20emphasizing%20product%20details%20sophisticated%20streetwear%20aesthetic%20quiet%20luxury%20style%20professional%20product%20photography&width=600&height=800&seq=clarity-black-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20black%20cotton%20t-shirt%20back%20view%20displayed%20on%20clean%20white%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20luxury%20basics%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=clarity-black-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20black%20cotton%20t-shirt%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20white%20print%20quality%20on%20clean%20white%20background%20luxury%20basics%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=clarity-black-detail&orientation=portrait'
        ],
        'Grey': [
          'https://readdy.ai/api/search-image?query=premium%20grey%20luxury%20t-shirt%20with%20bold%20black%20text%20Same%20shit%20Different%20day%20printed%20in%20modern%20typography%20on%20chest%20minimalist%20design%20high%20quality%20organic%20cotton%20fabric%20clean%20simple%20background%20emphasizing%20product%20details%20sophisticated%20streetwear%20aesthetic%20quiet%20luxury%20style%20professional%20product%20photography&width=600&height=800&seq=clarity-grey-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20grey%20cotton%20t-shirt%20back%20view%20displayed%20on%20clean%20white%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20luxury%20basics%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=clarity-grey-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20grey%20cotton%20t-shirt%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20print%20quality%20on%20clean%20white%20background%20luxury%20basics%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=clarity-grey-detail&orientation=portrait'
        ]
      }
    },
    { 
      id: 3, 
      name: 'WISDOM HOODIE', 
      quote: 'Know thyself', 
      price: 119, 
      category: 'hoodies', 
      description: 'Ancient wisdom meets modern design. This premium hoodie features a unique back print with philosophical typography. Heavyweight cotton blend ensures durability and warmth.', 
      sizes: ['S', 'M', 'L', 'XL'], 
      colors: ['Charcoal', 'Black', 'Stone'], 
      details: ['Heavyweight cotton blend', 'Unique back print design', 'Kangaroo pocket', 'Double-lined hood', 'Ribbed cuffs and hem'], 
      colorImages: {
        'Charcoal': [
          'https://readdy.ai/api/search-image?query=charcoal%20grey%20oversized%20hoodie%20with%20poetic%20verse%20typography%20in%20elegant%20script%20font%20printed%20across%20back%20displayed%20on%20neutral%20background%20luxury%20streetwear%20product%20shot%20emphasizing%20premium%20fabric%20texture%20and%20artistic%20lettering%20detail%20sophisticated%20monochrome%20aesthetic&width=600&height=800&seq=wisdom-charcoal-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=charcoal%20grey%20oversized%20hoodie%20front%20view%20displayed%20on%20neutral%20background%20luxury%20streetwear%20product%20shot%20emphasizing%20premium%20fabric%20texture%20sophisticated%20monochrome%20aesthetic&width=600&height=800&seq=wisdom-charcoal-front&orientation=portrait',
          'https://readdy.ai/api/search-image?query=charcoal%20grey%20hoodie%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20typography%20print%20quality%20luxury%20streetwear%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=wisdom-charcoal-detail&orientation=portrait'
        ],
        'Black': [
          'https://readdy.ai/api/search-image?query=black%20oversized%20hoodie%20with%20poetic%20verse%20typography%20in%20elegant%20script%20font%20printed%20across%20back%20displayed%20on%20neutral%20background%20luxury%20streetwear%20product%20shot%20emphasizing%20premium%20fabric%20texture%20and%20artistic%20lettering%20detail%20sophisticated%20aesthetic&width=600&height=800&seq=wisdom-black-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=black%20oversized%20hoodie%20front%20view%20displayed%20on%20neutral%20background%20luxury%20streetwear%20product%20shot%20emphasizing%20premium%20fabric%20texture%20sophisticated%20aesthetic&width=600&height=800&seq=wisdom-black-front&orientation=portrait',
          'https://readdy.ai/api/search-image?query=black%20hoodie%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20typography%20print%20quality%20luxury%20streetwear%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=wisdom-black-detail&orientation=portrait'
        ],
        'Stone': [
          'https://readdy.ai/api/search-image?query=stone%20grey%20oversized%20hoodie%20with%20poetic%20verse%20typography%20in%20elegant%20script%20font%20printed%20across%20back%20displayed%20on%20neutral%20background%20luxury%20streetwear%20product%20shot%20emphasizing%20premium%20fabric%20texture%20and%20artistic%20lettering%20detail%20sophisticated%20aesthetic&width=600&height=800&seq=wisdom-stone-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=stone%20grey%20oversized%20hoodie%20front%20view%20displayed%20on%20neutral%20background%20luxury%20streetwear%20product%20shot%20emphasizing%20premium%20fabric%20texture%20sophisticated%20aesthetic&width=600&height=800&seq=wisdom-stone-front&orientation=portrait',
          'https://readdy.ai/api/search-image?query=stone%20grey%20hoodie%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20typography%20print%20quality%20luxury%20streetwear%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=wisdom-stone-detail&orientation=portrait'
        ]
      }
    },
    { 
      id: 4, 
      name: 'TRUTH TEE', 
      quote: 'TOMORROW IS ANOTHER DAY', 
      price: 79, 
      category: 'tees', 
      description: 'Bold statements for bold individuals. Premium cotton construction with a modern fit. The striking typography makes this tee a conversation starter while maintaining sophistication.', 
      sizes: ['S', 'M', 'L', 'XL'], 
      colors: ['Black', 'White', 'Navy'], 
      details: ['Premium cotton construction', 'Modern fit', 'Bold typography print', 'Reinforced seams', 'Fade-resistant colors'], 
      colorImages: {
        'Black': [
          'https://readdy.ai/api/search-image?query=premium%20black%20luxury%20t-shirt%20with%20elegant%20white%20text%20TOMORROW%20IS%20ANOTHER%20DAY%20printed%20in%20bold%20typography%20on%20chest%20minimalist%20design%20high%20quality%20organic%20cotton%20fabric%20clean%20simple%20background%20emphasizing%20product%20details%20sophisticated%20streetwear%20aesthetic%20quiet%20luxury%20style%20professional%20product%20photography&width=600&height=800&seq=truth-black-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20black%20cotton%20t-shirt%20back%20view%20displayed%20on%20clean%20white%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20luxury%20basics%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=truth-black-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20black%20cotton%20t-shirt%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20white%20print%20quality%20on%20clean%20white%20background%20luxury%20basics%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=truth-black-detail&orientation=portrait'
        ],
        'White': [
          'https://readdy.ai/api/search-image?query=premium%20white%20luxury%20t-shirt%20with%20elegant%20black%20text%20TOMORROW%20IS%20ANOTHER%20DAY%20printed%20in%20bold%20typography%20on%20chest%20minimalist%20design%20high%20quality%20organic%20cotton%20fabric%20clean%20simple%20background%20emphasizing%20product%20details%20sophisticated%20streetwear%20aesthetic%20quiet%20luxury%20style%20professional%20product%20photography&width=600&height=800&seq=truth-white-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20white%20cotton%20t-shirt%20back%20view%20displayed%20on%20clean%20white%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20luxury%20basics%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=truth-white-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20white%20cotton%20t-shirt%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20black%20print%20quality%20on%20clean%20white%20background%20luxury%20basics%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=truth-white-detail&orientation=portrait'
        ],
        'Navy': [
          'https://readdy.ai/api/search-image?query=premium%20navy%20blue%20luxury%20t-shirt%20with%20elegant%20white%20text%20TOMORROW%20IS%20ANOTHER%20DAY%20printed%20in%20bold%20typography%20on%20chest%20minimalist%20design%20high%20quality%20organic%20cotton%20fabric%20clean%20simple%20background%20emphasizing%20product%20details%20sophisticated%20streetwear%20aesthetic%20quiet%20luxury%20style%20professional%20product%20photography&width=600&height=800&seq=truth-navy-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20navy%20blue%20cotton%20t-shirt%20back%20view%20displayed%20on%20clean%20white%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20luxury%20basics%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=truth-navy-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=premium%20navy%20blue%20cotton%20t-shirt%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20white%20print%20quality%20on%20clean%20white%20background%20luxury%20basics%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=truth-navy-detail&orientation=portrait'
        ]
      }
    },
    { 
      id: 5, 
      name: 'SERENITY HOODIE', 
      quote: 'Peace begins within', 
      price: 119, 
      category: 'hoodies', 
      description: 'Find your calm in style. Soft brushed cotton interior meets a refined exterior. The subtle chest print embodies tranquility and mindfulness in every thread.', 
      sizes: ['S', 'M', 'L', 'XL'], 
      colors: ['Cream', 'Stone', 'Sage'], 
      details: ['Soft brushed interior', 'Subtle chest print', 'Adjustable drawstrings', 'Side seam pockets', 'Eco-friendly dyes'], 
      colorImages: {
        'Cream': [
          'https://readdy.ai/api/search-image?query=cream%20beige%20oversized%20hoodie%20with%20philosophical%20statement%20in%20refined%20serif%20typography%20on%20front%20neutral%20background%20luxury%20streetwear%20product%20photography%20showcasing%20premium%20fabric%20weight%20and%20elegant%20print%20detail%20sophisticated%20aesthetic%20professional%20lighting&width=600&height=800&seq=serenity-cream-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=cream%20beige%20oversized%20hoodie%20back%20view%20displayed%20on%20neutral%20background%20luxury%20streetwear%20product%20photography%20showcasing%20premium%20fabric%20weight%20sophisticated%20aesthetic%20professional%20lighting&width=600&height=800&seq=serenity-cream-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=cream%20beige%20hoodie%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20typography%20print%20quality%20luxury%20streetwear%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=serenity-cream-detail&orientation=portrait'
        ],
        'Stone': [
          'https://readdy.ai/api/search-image?query=stone%20grey%20oversized%20hoodie%20with%20philosophical%20statement%20in%20refined%20serif%20typography%20on%20front%20neutral%20background%20luxury%20streetwear%20product%20photography%20showcasing%20premium%20fabric%20weight%20and%20elegant%20print%20detail%20sophisticated%20aesthetic%20professional%20lighting&width=600&height=800&seq=serenity-stone-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=stone%20grey%20oversized%20hoodie%20back%20view%20displayed%20on%20neutral%20background%20luxury%20streetwear%20product%20photography%20showcasing%20premium%20fabric%20weight%20sophisticated%20aesthetic%20professional%20lighting&width=600&height=800&seq=serenity-stone-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=stone%20grey%20hoodie%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20typography%20print%20quality%20luxury%20streetwear%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=serenity-stone-detail&orientation=portrait'
        ],
        'Sage': [
          'https://readdy.ai/api/search-image?query=sage%20green%20oversized%20hoodie%20with%20philosophical%20statement%20in%20refined%20serif%20typography%20on%20front%20neutral%20background%20luxury%20streetwear%20product%20photography%20showcasing%20premium%20fabric%20weight%20and%20elegant%20print%20detail%20sophisticated%20aesthetic%20professional%20lighting&width=600&height=800&seq=serenity-sage-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=sage%20green%20oversized%20hoodie%20back%20view%20displayed%20on%20neutral%20background%20luxury%20streetwear%20product%20photography%20showcasing%20premium%20fabric%20weight%20sophisticated%20aesthetic%20professional%20lighting&width=600&height=800&seq=serenity-sage-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=sage%20green%20hoodie%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20typography%20print%20quality%20luxury%20streetwear%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=serenity-sage-detail&orientation=portrait'
        ]
      }
    },
    { 
      id: 6, 
      name: 'GRACE TEE', 
      quote: 'Elegance is an attitude', 
      price: 79, 
      category: 'tees', 
      description: 'Effortless elegance in every wear. Lightweight organic cotton with a flattering cut. The refined typography adds a touch of sophistication to your casual wardrobe.', 
      sizes: ['S', 'M', 'L', 'XL'], 
      colors: ['White', 'Cream', 'Light Grey'], 
      details: ['Lightweight organic cotton', 'Flattering cut', 'Refined typography', 'Soft hand feel', 'Sustainable materials'], 
      colorImages: {
        'White': [
          'https://readdy.ai/api/search-image?query=white%20premium%20cotton%20t-shirt%20with%20inspirational%20phrase%20in%20clean%20sans-serif%20typography%20simple%20white%20background%20professional%20product%20photography%20showcasing%20fabric%20texture%20and%20print%20quality%20luxury%20basics%20minimalist%20style%20ecommerce%20presentation&width=600&height=800&seq=grace-white-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=white%20premium%20cotton%20t-shirt%20back%20view%20displayed%20on%20clean%20white%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20luxury%20basics%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=grace-white-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=white%20premium%20cotton%20t-shirt%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20print%20quality%20on%20clean%20white%20background%20luxury%20basics%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=grace-white-detail&orientation=portrait'
        ],
        'Cream': [
          'https://readdy.ai/api/search-image?query=cream%20premium%20cotton%20t-shirt%20with%20inspirational%20phrase%20in%20clean%20sans-serif%20typography%20simple%20neutral%20background%20professional%20product%20photography%20showcasing%20fabric%20texture%20and%20print%20quality%20luxury%20basics%20minimalist%20style%20ecommerce%20presentation&width=600&height=800&seq=grace-cream-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=cream%20premium%20cotton%20t-shirt%20back%20view%20displayed%20on%20clean%20neutral%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20luxury%20basics%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=grace-cream-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=cream%20premium%20cotton%20t-shirt%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20print%20quality%20on%20clean%20neutral%20background%20luxury%20basics%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=grace-cream-detail&orientation=portrait'
        ],
        'Light Grey': [
          'https://readdy.ai/api/search-image?query=light%20grey%20premium%20cotton%20t-shirt%20with%20inspirational%20phrase%20in%20clean%20sans-serif%20typography%20simple%20neutral%20background%20professional%20product%20photography%20showcasing%20fabric%20texture%20and%20print%20quality%20luxury%20basics%20minimalist%20style%20ecommerce%20presentation&width=600&height=800&seq=grace-lightgrey-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=light%20grey%20premium%20cotton%20t-shirt%20back%20view%20displayed%20on%20clean%20neutral%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20luxury%20basics%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=grace-lightgrey-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=light%20grey%20premium%20cotton%20t-shirt%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20print%20quality%20on%20clean%20neutral%20background%20luxury%20basics%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=grace-lightgrey-detail&orientation=portrait'
        ]
      }
    },
    { 
      id: 7, 
      name: 'MINDFUL HOODIE', 
      quote: 'Present moment, only moment', 
      price: 119, 
      category: 'hoodies', 
      description: 'Stay present, stay comfortable. Premium heavyweight cotton with a relaxed fit. The zen-inspired print serves as a daily reminder to live in the moment.', 
      sizes: ['S', 'M', 'L', 'XL'], 
      colors: ['Dark Grey', 'Black', 'Charcoal'], 
      details: ['Premium heavyweight cotton', 'Zen-inspired print', 'Relaxed fit', 'Fleece-lined hood', 'Quality construction'], 
      colorImages: {
        'Dark Grey': [
          'https://readdy.ai/api/search-image?query=dark%20grey%20premium%20hoodie%20with%20zen%20inspired%20quote%20in%20minimalist%20typography%20on%20chest%20clean%20white%20background%20luxury%20streetwear%20product%20photography%20highlighting%20fabric%20quality%20and%20elegant%20print%20detail%20sophisticated%20aesthetic%20professional%20studio%20lighting&width=600&height=800&seq=mindful-darkgrey-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=dark%20grey%20premium%20hoodie%20back%20view%20displayed%20on%20clean%20white%20background%20luxury%20streetwear%20product%20photography%20highlighting%20fabric%20quality%20sophisticated%20aesthetic%20professional%20studio%20lighting&width=600&height=800&seq=mindful-darkgrey-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=dark%20grey%20hoodie%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20typography%20print%20quality%20luxury%20streetwear%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=mindful-darkgrey-detail&orientation=portrait'
        ],
        'Black': [
          'https://readdy.ai/api/search-image?query=black%20premium%20hoodie%20with%20zen%20inspired%20quote%20in%20minimalist%20typography%20on%20chest%20clean%20white%20background%20luxury%20streetwear%20product%20photography%20highlighting%20fabric%20quality%20and%20elegant%20print%20detail%20sophisticated%20aesthetic%20professional%20studio%20lighting&width=600&height=800&seq=mindful-black-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=black%20premium%20hoodie%20back%20view%20displayed%20on%20clean%20white%20background%20luxury%20streetwear%20product%20photography%20highlighting%20fabric%20quality%20sophisticated%20aesthetic%20professional%20studio%20lighting&width=600&height=800&seq=mindful-black-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=black%20hoodie%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20typography%20print%20quality%20luxury%20streetwear%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=mindful-black-detail&orientation=portrait'
        ],
        'Charcoal': [
          'https://readdy.ai/api/search-image?query=charcoal%20premium%20hoodie%20with%20zen%20inspired%20quote%20in%20minimalist%20typography%20on%20chest%20clean%20white%20background%20luxury%20streetwear%20product%20photography%20highlighting%20fabric%20quality%20and%20elegant%20print%20detail%20sophisticated%20aesthetic%20professional%20studio%20lighting&width=600&height=800&seq=mindful-charcoal-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=charcoal%20premium%20hoodie%20back%20view%20displayed%20on%20clean%20white%20background%20luxury%20streetwear%20product%20photography%20highlighting%20fabric%20quality%20sophisticated%20aesthetic%20professional%20studio%20lighting&width=600&height=800&seq=mindful-charcoal-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=charcoal%20hoodie%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20typography%20print%20quality%20luxury%20streetwear%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=mindful-charcoal-detail&orientation=portrait'
        ]
      }
    },
    { 
      id: 8, 
      name: 'COURAGE TEE', 
      quote: 'Don\'t let idiots ruin your day', 
      price: 79, 
      category: 'tees', 
      description: 'Wear your freedom. Soft, breathable cotton with a relaxed silhouette. The liberating message reminds you that true freedom comes from within.', 
      sizes: ['S', 'M', 'L', 'XL'], 
      colors: ['Charcoal', 'Black', 'Stone'], 
      details: ['Soft breathable cotton', 'Relaxed silhouette', 'Liberating message print', 'Comfortable wear', 'Durable construction'], 
      colorImages: {
        'Charcoal': [
          'https://readdy.ai/api/search-image?query=charcoal%20grey%20premium%20cotton%20t-shirt%20with%20inspirational%20phrase%20in%20elegant%20typography%20centered%20on%20front%20simple%20white%20background%20professional%20product%20photography%20showcasing%20fabric%20texture%20and%20print%20quality%20luxury%20basics%20minimalist%20style%20ecommerce%20presentation&width=600&height=800&seq=courage-charcoal-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=charcoal%20grey%20premium%20cotton%20t-shirt%20back%20view%20displayed%20on%20clean%20white%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20luxury%20basics%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=courage-charcoal-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=charcoal%20grey%20premium%20cotton%20t-shirt%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20print%20quality%20on%20clean%20white%20background%20luxury%20basics%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=courage-charcoal-detail&orientation=portrait'
        ],
        'Black': [
          'https://readdy.ai/api/search-image?query=black%20premium%20cotton%20t-shirt%20with%20inspirational%20phrase%20in%20elegant%20white%20typography%20centered%20on%20front%20simple%20white%20background%20professional%20product%20photography%20showcasing%20fabric%20texture%20and%20print%20quality%20luxury%20basics%20minimalist%20style%20ecommerce%20presentation&width=600&height=800&seq=courage-black-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=black%20premium%20cotton%20t-shirt%20back%20view%20displayed%20on%20clean%20white%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20luxury%20basics%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=courage-black-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=black%20premium%20cotton%20t-shirt%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20print%20quality%20on%20clean%20white%20background%20luxury%20basics%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=courage-black-detail&orientation=portrait'
        ],
        'Stone': [
          'https://readdy.ai/api/search-image?query=stone%20grey%20premium%20cotton%20t-shirt%20with%20inspirational%20phrase%20in%20elegant%20typography%20centered%20on%20front%20simple%20white%20background%20professional%20product%20photography%20showcasing%20fabric%20texture%20and%20print%20quality%20luxury%20basics%20minimalist%20style%20ecommerce%20presentation&width=600&height=800&seq=courage-stone-main&orientation=portrait',
          'https://readdy.ai/api/search-image?query=stone%20grey%20premium%20cotton%20t-shirt%20back%20view%20displayed%20on%20clean%20white%20background%20flat%20lay%20product%20photography%20minimalist%20composition%20emphasizing%20fabric%20quality%20luxury%20basics%20aesthetic%20professional%20ecommerce%20style&width=600&height=800&seq=courage-stone-back&orientation=portrait',
          'https://readdy.ai/api/search-image?query=stone%20grey%20premium%20cotton%20t-shirt%20detail%20close%20up%20shot%20showing%20fabric%20texture%20and%20print%20quality%20on%20clean%20neutral%20background%20luxury%20basics%20aesthetic%20professional%20product%20photography&width=600&height=800&seq=courage-stone-detail&orientation=portrait'
        ]
      }
    },
  ];

  const product = allProducts.find(p => p.id === Number(id)) || allProducts[0];

  // Set default color when product loads
  useEffect(() => {
    if (product.colors && product.colors.length > 0) {
      setSelectedColor(product.colors[0]);
    }
  }, [product.id]);

  // Reset selected image when color changes
  useEffect(() => {
    setSelectedImage(0);
  }, [selectedColor]);

  // Get current color images
  const getCurrentImages = () => {
    if (product.colorImages && selectedColor && product.colorImages[selectedColor]) {
      return product.colorImages[selectedColor];
    }
    // Fallback to first color's images if selected color not found
    const firstColor = product.colors[0];
    return product.colorImages?.[firstColor] || [];
  };

  const formatPrice = (price: number) => {
    if (!localCurrency) {
      return `$${price}.00`;
    }
    
    const convertedPrice = (price * localCurrency.rate).toFixed(2);
    return (
      <div className="flex flex-col gap-1">
        <span className="text-2xl">${price}.00 USD</span>
        <span className="text-lg text-neutral-500">
          {localCurrency.symbol}{convertedPrice} {localCurrency.code}
        </span>
      </div>
    );
  };

  const handleAddToCart = () => {
    const currentImages = getCurrentImages();
    addToCart({
      productId: product.id,
      name: product.name,
      price: product.price,
      size: selectedSize,
      quantity: quantity,
      image: currentImages[0] || '',
      quote: product.quote
    });
    setAddedToCart(true);
    setTimeout(() => setAddedToCart(false), 2000);
  };

  return (
    <div className="min-h-screen bg-white">
      <SearchModal isOpen={searchModalOpen} onClose={() => setSearchModalOpen(false)} />
      
      {/* Top Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white z-50 border-b border-black/10">
        <div className="px-6 py-4 flex items-center justify-between">
          {/* Mobile: Hamburger on left */}
          <button 
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>

          {/* Desktop: Menu items on left */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/shop" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer">NEW ARRIVALS</Link>
            <div 
              className="relative"
              onMouseEnter={() => setCollectionDropdownOpen(true)}
              onMouseLeave={() => setCollectionDropdownOpen(false)}
            >
              <button className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer flex items-center gap-1">
                COLLECTION
                <i className="ri-arrow-down-s-line text-lg"></i>
              </button>
              {collectionDropdownOpen && (
                <div className="absolute top-full left-0 pt-2">
                  <div className="bg-white border border-black/10 py-2 min-w-[160px] shadow-lg">
                    <Link to="/shop?category=hoodies" className="block px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer">
                      HOODIES
                    </Link>
                    <Link to="/shop?category=tees" className="block px-6 py-2 text-sm tracking-[0.2em] hover:bg-neutral-50 cursor-pointer">
                      T-SHIRTS
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <Link to="/about" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer">ABOUT</Link>
          </div>

          {/* Logo in center */}
          <Link to="/" className="cursor-pointer absolute left-1/2 transform -translate-x-1/2">
            <img 
              src="https://static.readdy.ai/image/6ad45fecb24f9c50dfb1488fc3ba7d2f/1bfa6c5bfe10d7e974b284f405d55895.png" 
              alt="DASHY" 
              className="h-7 md:h-8"
            />
          </Link>
          
          {/* Icons on right */}
          <div className="flex items-center gap-4">
            <button 
              onClick={() => setSearchModalOpen(true)}
              className="w-10 h-10 hidden md:flex items-center justify-center cursor-pointer"
            >
              <i className="ri-search-line text-xl"></i>
            </button>
            <Link to="/wishlist" className="w-10 h-10 flex items-center justify-center cursor-pointer relative">
              <i className="ri-heart-line text-xl"></i>
              {wishlistTotal > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                  {wishlistTotal}
                </span>
              )}
            </Link>
            <Link to="/cart" className="w-10 h-10 flex items-center justify-center cursor-pointer relative">
              <i className="ri-shopping-bag-line text-xl"></i>
              {totalItems > 0 && (
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                  {totalItems}
                </span>
              )}
            </Link>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-black/10 bg-white">
            <div className="px-6 py-4 flex flex-col gap-4">
              <Link to="/shop" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>NEW ARRIVALS</Link>
              <div>
                <button 
                  onClick={() => setCollectionDropdownOpen(!collectionDropdownOpen)}
                  className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer flex items-center gap-1 w-full"
                >
                  COLLECTION
                  <i className={`ri-arrow-${collectionDropdownOpen ? 'up' : 'down'}-s-line text-lg`}></i>
                </button>
                {collectionDropdownOpen && (
                  <div className="pl-4 mt-2 space-y-2">
                    <Link to="/shop?category=hoodies" className="block text-sm tracking-[0.2em] text-neutral-600 hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
                      HOODIES
                    </Link>
                    <Link to="/shop?category=tees" className="block text-sm tracking-[0.2em] text-neutral-600 hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>
                      T-SHIRTS
                    </Link>
                  </div>
                )}
              </div>
              <Link to="/about" className="text-sm tracking-[0.2em] hover:opacity-60 transition-opacity cursor-pointer" onClick={() => setMobileMenuOpen(false)}>ABOUT</Link>
              <div className="flex gap-4 pt-4 border-t border-black/10">
                <button 
                  onClick={() => {
                    setSearchModalOpen(true);
                    setMobileMenuOpen(false);
                  }}
                  className="w-10 h-10 flex items-center justify-center cursor-pointer"
                >
                  <i className="ri-search-line text-xl"></i>
                </button>
                <Link to="/wishlist" className="w-10 h-10 flex items-center justify-center cursor-pointer relative" onClick={() => setMobileMenuOpen(false)}>
                  <i className="ri-heart-line text-xl"></i>
                  {wishlistTotal > 0 && (
                    <span className="absolute -top-1 -right-1 w-5 h-5 bg-black text-white text-xs flex items-center justify-center rounded-full">
                      {wishlistTotal}
                    </span>
                  )}
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Product Content */}
      <div className="pt-32 pb-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* Images */}
            <div>
              <div className="aspect-[3/4] bg-neutral-50 mb-4 overflow-hidden">
                <img 
                  src={getCurrentImages()[selectedImage] || ''}
                  alt={`${product.name} - ${selectedColor}`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="grid grid-cols-4 gap-3">
                {getCurrentImages().map((img, idx) => (
                  <button
                    key={`${selectedColor}-${idx}`}
                    onClick={() => setSelectedImage(idx)}
                    className={`aspect-[3/4] bg-neutral-50 overflow-hidden cursor-pointer transition-all ${selectedImage === idx ? 'ring-2 ring-black' : 'ring-1 ring-black/10 hover:ring-black/30'}`}
                  >
                    <img 
                      src={img}
                      alt={`${selectedColor} view ${idx + 1}`}
                      className="w-full h-full object-cover object-top"
                    />
                  </button>
                ))}
              </div>
            </div>

            {/* Product Info */}
            <div>
              <h1 className="text-2xl md:text-4xl font-light tracking-[0.15em] md:tracking-[0.2em] mb-3 md:mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
                {product.name}
              </h1>
              <p className="text-base md:text-lg text-neutral-600 italic mb-4 md:mb-6">"{product.quote}"</p>
              <div className="mb-6 md:mb-8">
                {formatPrice(product.price)}
              </div>

              <div className="mb-6 md:mb-8">
                <p className="text-xs md:text-sm tracking-[0.05em] md:tracking-[0.1em] mb-4 md:mb-6 leading-relaxed">
                  {product.description}
                </p>
              </div>

              {/* Color Selection */}
              <div className="mb-6 md:mb-8">
                <label className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] mb-3 md:mb-4 block">COLOR: {selectedColor}</label>
                <div className="flex gap-2 md:gap-3">
                  {product.colors.map(color => (
                    <button
                      key={color}
                      onClick={() => setSelectedColor(color)}
                      className={`w-10 h-10 md:w-12 md:h-12 border-2 cursor-pointer relative ${
                        selectedColor === color 
                          ? 'border-black' 
                          : 'border-black/20 hover:border-black/40'
                      }`}
                      style={{
                        backgroundColor: 
                          color === 'Black' ? '#000000' :
                          color === 'White' ? '#FFFFFF' :
                          color === 'Charcoal' ? '#36454F' :
                          color === 'Navy' ? '#000080' :
                          color === 'Grey' ? '#808080' :
                          color === 'Stone' ? '#928E85' :
                          color === 'Cream' ? '#FFFDD0' :
                          color === 'Light Grey' ? '#D3D3D3' :
                          color === 'Dark Grey' ? '#4A4A4A' :
                          color === 'Sage' ? '#9CAF88' : '#CCCCCC'
                      }}
                      title={color}
                    >
                      {selectedColor === color && (
                        <i className={`ri-check-line text-lg md:text-xl absolute inset-0 flex items-center justify-center ${
                          ['White', 'Cream', 'Light Grey', 'Stone', 'Sage'].includes(color) ? 'text-black' : 'text-white'
                        }`}></i>
                      )}
                    </button>
                  ))}
                </div>
              </div>

              {/* Size Selection */}
              <div className="mb-6 md:mb-8">
                <div className="flex items-center justify-between mb-3 md:mb-4">
                  <label className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em]">SIZE</label>
                  <button 
                    onClick={() => setSizeGuideOpen(true)}
                    className="text-xs tracking-[0.05em] md:tracking-[0.1em] text-neutral-500 hover:text-black cursor-pointer whitespace-nowrap"
                  >
                    SIZE GUIDE
                  </button>
                </div>
                <div className="grid grid-cols-4 gap-2">
                  {product.sizes.map(size => (
                    <button
                      key={size}
                      onClick={() => setSelectedSize(size)}
                      className={`py-2 md:py-3 text-xs md:text-sm tracking-[0.05em] md:tracking-[0.1em] border cursor-pointer whitespace-nowrap ${
                        selectedSize === size 
                          ? 'border-black bg-black text-white' 
                          : 'border-black/20 hover:border-black'
                      }`}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              </div>

              {/* Quantity */}
              <div className="mb-6 md:mb-8">
                <label className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] mb-3 md:mb-4 block">QUANTITY</label>
                <div className="flex items-center gap-3 md:gap-4">
                  <button 
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    className="w-10 h-10 md:w-12 md:h-12 border border-black/20 flex items-center justify-center hover:border-black cursor-pointer"
                  >
                    <i className="ri-subtract-line"></i>
                  </button>
                  <span className="text-base md:text-lg w-10 md:w-12 text-center">{quantity}</span>
                  <button 
                    onClick={() => setQuantity(quantity + 1)}
                    className="w-10 h-10 md:w-12 md:h-12 border border-black/20 flex items-center justify-center hover:border-black cursor-pointer"
                  >
                    <i className="ri-add-line"></i>
                  </button>
                </div>
              </div>

              {/* Add to Cart */}
              <button 
                onClick={handleAddToCart}
                className="w-full py-3 md:py-4 bg-black text-white text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] hover:bg-neutral-800 transition-colors mb-3 md:mb-4 cursor-pointer whitespace-nowrap"
              >
                {addedToCart ? 'ADDED TO CART ✓' : 'ADD TO CART'}
              </button>
              <button 
                onClick={() => {
                  if (isInWishlist(product.id)) {
                    removeFromWishlist(product.id);
                  } else {
                    addToWishlist({
                      id: product.id,
                      name: product.name,
                      price: product.price,
                      image: getCurrentImages()[0] || '',
                      quote: product.quote
                    });
                  }
                }}
                className="w-full py-3 md:py-4 border border-black text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] hover:bg-black hover:text-white transition-all cursor-pointer whitespace-nowrap"
              >
                <i className={`${isInWishlist(product.id) ? 'ri-heart-fill' : 'ri-heart-line'} mr-2`}></i>
                {isInWishlist(product.id) ? 'REMOVE FROM WISHLIST' : 'ADD TO WISHLIST'}
              </button>

              {/* Product Details */}
              <div className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-black/10">
                <h3 className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] mb-3 md:mb-4">DETAILS</h3>
                <ul className="space-y-1 md:space-y-2 text-xs md:text-sm text-neutral-600">
                  {product.details.map((detail, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="mr-2">•</span>
                      <span>{detail}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Shipping Info */}
              <div className="mt-6 md:mt-8 pt-6 md:pt-8 border-t border-black/10">
                <div className="flex items-start gap-3 md:gap-4">
                  <i className="ri-truck-line text-lg md:text-xl"></i>
                  <div>
                    <h4 className="text-xs md:text-sm tracking-[0.05em] md:tracking-[0.1em] mb-1">FREE SHIPPING</h4>
                    <p className="text-xs text-neutral-600">On orders over $200</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* You May Also Like */}
      <section className="py-16 md:py-24 px-6 bg-neutral-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-light tracking-[0.15em] md:tracking-[0.2em] text-center mb-12 md:mb-16" style={{ fontFamily: '"Playfair Display", serif' }}>
            YOU MAY ALSO LIKE
          </h2>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8" data-product-shop>
            {allProducts
              .filter(p => p.id !== product.id) // Exclude current product
              .slice(0, 4) // Show only first 4 different products
              .map(relatedProduct => (
                <Link key={relatedProduct.id} to={`/product/${relatedProduct.id}`} className="group cursor-pointer">
                  <div className="relative aspect-[3/4] bg-white mb-3 md:mb-4 overflow-hidden">
                    <img 
                      src={relatedProduct.colorImages?.[relatedProduct.colors[0]]?.[0] || ''}
                      alt={relatedProduct.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <h3 className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] mb-1 md:mb-2">{relatedProduct.name}</h3>
                  <p className="text-xs md:text-sm">${relatedProduct.price}.00</p>
                </Link>
              ))}
          </div>
        </div>
      </section>

      {/* Size Guide Modal */}
      <SizeGuideModal isOpen={sizeGuideOpen} onClose={() => setSizeGuideOpen(false)} />

      {/* Footer */}
      <footer className="bg-black text-white py-12 md:py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
            <div>
              <h3 className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] mb-4 md:mb-6">DASHY</h3>
              <p className="text-xs md:text-sm text-neutral-400 leading-relaxed">
                Quiet luxury streetwear with meaningful messages for the modern individual.
              </p>
            </div>
            
            <div>
              <h4 className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] mb-3 md:mb-4">SHOP</h4>
              <ul className="space-y-2 md:space-y-3 text-xs md:text-sm text-neutral-400">
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">New Arrivals</Link></li>
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">Hoodies</Link></li>
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">T-Shirts</Link></li>
                <li><Link to="/shop" className="hover:text-white transition-colors cursor-pointer">Collections</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] mb-3 md:mb-4">COMPANY</h4>
              <ul className="space-y-2 md:space-y-3 text-xs md:text-sm text-neutral-400">
                <li><Link to="/about" className="hover:text-white transition-colors cursor-pointer">About Us</Link></li>
                <li><Link to="/contact" className="hover:text-white transition-colors cursor-pointer">Contact Us</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-xs md:text-sm tracking-[0.15em] md:tracking-[0.2em] mb-3 md:mb-4">FOLLOW US</h4>
              <div className="flex gap-4">
                <a href="https://instagram.com/Dashyfashionofficial" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 hover:bg-white hover:text-black transition-all cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
          
          <div className="pt-6 md:pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4 text-xs md:text-sm text-neutral-400">
            <p>© 2024 DASHY FASHION LIMITED. All rights reserved.</p>
            <div className="flex gap-4 md:gap-6">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">Terms of Service</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
